/* eslint-disable no-return-assign */
import { checkIfType } from '../utils';
import Logger from '../utils/logger';

window.apiConfig = {};

const getApiAuthToken = () => {
  if (window.apiAuthToken === 'undefined'
    || window.apiAuthToken === 'null') return undefined;
  return window.apiAuthToken;
};

export const setApiAuthToken = (token) => {
  window.apiAuthToken = token;
};

export const removeApiAuthToken = () => {
  window.apiAuthToken = undefined;
};

/**
 * sets config at build time, see widget and consumer
*/

export const setApiConfig = (apiConfig) => {
  window.apiConfig = { ...apiConfig };
};

export const getApiConfig = (key) => (window.apiConfig[key]);

const buildApiHeaders = ({
  origin, apiKey, apiAuthToken, contentType, sessionId,
}) => {
  const defaultHeaders = {
    'X-Origin': origin,
    Authorization: `ResyAPI api_key="${apiKey}"`,
    'Cache-Control': 'no-cache',
  };
  const apiAuthHeaders = apiAuthToken
    ? {
      'X-Resy-Auth-Token': apiAuthToken,
      'X-Resy-Universal-Auth': apiAuthToken,
    } : {};
  const contentTypeHeaders = contentType ? { 'Content-Type': contentType } : {};
  const sessionHeaders = sessionId ? { 'X-Session-Id': sessionId } : {};
  return {
    ...defaultHeaders, ...apiAuthHeaders, ...contentTypeHeaders, ...sessionHeaders,
  };
};

export const getApiHeaders = ({ authToken, contentType, sessionId } = {}) => {
  const args = {
    origin: getApiConfig('Config').origin,
    apiKey: getApiConfig('Config').apiKey,
    apiAuthToken: authToken ?? getApiAuthToken(),
    contentType,
    sessionId,
  };
  return buildApiHeaders(args);
};

export const handlePostUserProfileLocationsParams = (data) => {
  const params = {
    struct_location: JSON.stringify(data.locationCodes),
  };
  /* istanbul ignore else */
  if ('isMarketable' in data) {
    params.is_marketable = data.isMarketable ? 1 : 0;
  }
  /* istanbul ignore else */
  if ('primaryLocationCode' in data) {
    // When no primary location is selected, this is null
    // and the API expects an empty string
    params.primary_location_code = data.primaryLocationCode || '';
  }
  return params;
};

export const handlePostConsumerGuestTagsParams = (data) => {
  let params = [];
  /* istanbul ignore else */
  if ('dietRestrictionIds' in data) {
    params = data.dietRestrictionIds.reduce((result, item) => {
      result.push({ id: parseInt(item, 10) });
      return result;
    }, params);
  }
  /* istanbul ignore else */
  if ('allergyIds' in data) {
    params = data.allergyIds.reduce((result, item) => {
      result.push({ id: parseInt(item, 10) });
      return result;
    }, params);
  }
  return params;
};

export const handlePostUserProfileAllergiesParams = (data) => {
  const params = {};
  if ('allergyText' in data) {
    params.allergy_text = data.allergyText;
  }
  if ('dietRestrictionIds' in data) {
    params.struct_diet_restriction = JSON.stringify({
      diet_restriction_ids: data.dietRestrictionIds,
      diet_restriction_other: [],
    });
  }
  if ('allergyIds' in data) {
    params.struct_allergy = JSON.stringify({
      allergy_ids: data.allergyIds,
      allergy_other: [],
    });
  }
  return params;
};

export const handlePostUserResetPasswordParams = (data) => {
  const { key, password } = data;
  /*
   * backwards support for deprecated unique_key
   * remove once all unique_key's are phased out
   */
  const isLegacyUniqueKey = key.match(/U[a-zA-Z0-9]{13}/);
  const tokenKey = isLegacyUniqueKey
    ? 'unique_key'
    : 'token';

  const params = {
    [tokenKey]: key,
    password,
  };
  return params;
};

export const handlePostRateReservationParams = (data) => {
  let isError = false;
  const params = {
    value: data.rating,
    struct_tags: data.tags,
  };
  /* istanbul ignore else */
  if ('authToken' in data && !!data.authToken) {
    params.auth_token = data.authToken;
  }
  /* istanbul ignore else */
  if ('uniqueKey' in data && !!data.uniqueKey) {
    params.unique_key = data.uniqueKey;
  } else if ('resyToken' in data && !!data.resyToken) {
    params.resy_token = data.resyToken;
  } else {
    Logger.error('[ERROR] postRateReservation() /3/rate/reservation is missing a required parameter.');
    isError = true;
  }
  /* istanbul ignore else */
  if ('comments' in data && checkIfType.isString(data.comments) && data.comments !== '') {
    params.comments = data.comments;
  }

  return isError ? null : params;
};
